import { updatePartnerProductStatus } from "api/Partners";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdatePartnerProductStatus = () => {
    const queryClient = useQueryClient();
    return useMutation(updatePartnerProductStatus, {
        onSuccess: () => {
            toast.success("Product of Partner status updated successfully!");
            queryClient.invalidateQueries('partnersProducts');
        },
        onError: () => {
            toast.error("Partner Product status update failed! Please try again later.");
        }
    })
}